import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { createDirectors, getAllDirectors } from "../../../apis/directors";
import moment from "moment";

const initialValues = {
  director_name: "",
  director_email: "",
  phone_number: "",
  identification_number: "",
  type: "",
  address: {
    street: "",
    city: "",
    state: "",
    pincode: "",
  },
};
type EmployeeResponse = {
  id: number;
  director_name: string;
  director_email: string;
  phone_number: number;
  identification_number: string;
  type: string;
  address: string; // stringified JSON
};
type EmployeeData = {
  key: number;
  Name: string;
  Email: string;
  Phone: number;
  DIN: string;
  Type: string;
  Address: string;
  id: number;
  Status: string;
};


const DirectorList = () => {


  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const { director_name, director_email, phone_number, identification_number, type, address } = formData;
  const [state, setState] = useState({
    start: moment().subtract(6, "days"),
    end: moment(),
  });
  const { start, end } = state;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;

    if (name.includes("address.")) {
      const key = name.split(".")[1];
      setFormData({
        ...formData,
        address: {
          ...formData.address,
          [key]: value,
        },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: start.format("MM/DD/YYYY"),
        end_date: end.format("MM/DD/YYYY"),
      };
      const response = await getAllDirectors(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => {
          const addressObj = item.address ? JSON.parse(item.address) : {};

          return {
            key: `${i + 1}`,
            Name: item.director_name,
            Email: item.director_email,
            Phone: item.phone_number,
            DIN: item.identification_number,
            Type: item.type,
            Address: `${addressObj.city || ""}, ${addressObj.state || ""}`,
            id: item.id,
            Status: "Active", // static for now (API not giving status)
          };
        }
      );
      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [state]);

  const handleChangeStatus = (data: { id: any; status: string }) => {
    console.error("Status change data:", data);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
    },
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
    },
    {
      title: "Phone",
      dataIndex: "Phone",
    },
    {
      title: "DIN",
      dataIndex: "DIN",
    },
    {
      title: "Type",
      dataIndex: "Type",
    },
    {
      title: "Address",
      dataIndex: "Address",
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: EmployeeData) => (
        <span
          className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
          onClick={() => handleChangeStatus({ id: record.id, status: text })}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex gap-2">
          <Link
            to={`/director-capital?id=${record.id}`}
            className="btn btn-sm btn-success"
          >
            Capital and Loans
          </Link>
        </div>
      ),
    }
  ];

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const payload = {
      ...formData,
      status: "active",
    };
    try {
      const response = await createDirectors(payload);
      if (response.status === true) {
        setSuccessCreation(true);
        fetchAllEmployees();
      }
    } catch (error) {
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New User
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name\Mobile"
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {allEmployeeData && allEmployeeData.length > 0 && (
                <Table
                  dataSource={allEmployeeData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Director</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">

                      <div className="col-md-6">
                        <label>Full Name *</label>
                        <input type="text" name="director_name" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>director_email *</label>
                        <input type="director_email" name="director_email" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>Phone Number *</label>
                        <input type="text" name="phone_number" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>Identification Number *</label>
                        <input type="text" name="identification_number" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>Type *</label>
                        <select name="type" onChange={handleChange} className="form-control">
                          <option value="">Select</option>
                          <option value="director">Director</option>
                          <option value="investor">Investor</option>
                        </select>
                      </div>

                      {/* Address Fields */}
                      <div className="col-md-6">
                        <label>Street</label>
                        <input type="text" name="address.street" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>City</label>
                        <input type="text" name="address.city" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>State</label>
                        <input type="text" name="address.state" onChange={handleChange} className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label>Pincode</label>
                        <input type="text" name="address.pincode" onChange={handleChange} className="form-control" />
                      </div>

                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default DirectorList;
